// Plan groups
export const TEAMS = "teams";
export const FAMILY_VPN = "family";
export const FREE_PLAN = "freeplan";

// Payment wall logical Key
export const STRIPE_LOGICAL_KEY = "stripe";
export const PAYPAL_LOGICAL_KEY = "paypal";
export const GPAY_LOGICAL_KEY = "gpay";
export const PAYMENT_WALL_KEY = "paymentwall";
export const APPLE_KEY = "applepay";
export const COIN_PAYMENT_KEY = "coinpayment";
export const FREE_PLAN_KEY = "freeplan";

// Teams Templates checkout varibles
export const TEAMS_TEMPLATE_V2 = "recurly-teams-v2";
export const TEAMS_FREE_PLAN_TEMPLATE = "recurly-teams-free-plan";
export const TEAMS_FREE_PLAN_TEMPLATE_V2 = "recurly-teams-free-plan-v2";

// PLG Template checkout varibles
export const IOS_CHECKOUT_V2 = "recurly-ios-template-v2";
export const IOS_CHECKOUT_V3 = "recurly-ios-template-v3";
export const PLG_CHECKOUT_V2_TEAMS = "recurly-plg-v2-teams";
export const PASSWORD_MANAGER_TEMPLATE_V2 = "password-manager-template-v2";
export const PLG_CHECKOUT_TEMPLATES = [PLG_CHECKOUT_V2_TEAMS];
export const IOS_CHECKOUT_TEMPLATES = [IOS_CHECKOUT_V2, IOS_CHECKOUT_V3];
export const WINDOWS_IOS_CHECKOUT_TEMPLATES = [PASSWORD_MANAGER_TEMPLATE_V2];

export const SAME_RECURLY_STYLE_TEMPLATES = [TEAMS_TEMPLATE_V2, TEAMS_FREE_PLAN_TEMPLATE,TEAMS_FREE_PLAN_TEMPLATE_V2];
export const RECURLY_PROPLAN_V10 = "recurly-proplan-teams-v10";

// DPP Template checkout variables
export const RECURLY_DPP_V1_TEMPLATE = "recurly-dpp-v1";
export const RECURLY_APP_EMAIL_TEMPLATE = "recurly-app-email";
export const DPP_CHECKOUT_TEMPLATES = [RECURLY_DPP_V1_TEMPLATE, RECURLY_APP_EMAIL_TEMPLATE];
// GA4 event fired when the thank-you QR is shown, per template
export const QR_VIEW_EVENTS = {
  [RECURLY_DPP_V1_TEMPLATE]: "dpp_thankyou_qr_view",
  [RECURLY_APP_EMAIL_TEMPLATE]: "single_checkout_freetrial",
};

export const OS_IOS = "ios";
export const OS_MAC = "mac";
export const OS_WINDOWS = "windows";
export const OS_ANDROID = "android";
export const OS_OTHER = "other";

// Payment Wall Name Translation
export const paymentNameTranslation = {
    [STRIPE_LOGICAL_KEY]: "stripe_V2",
    [PAYPAL_LOGICAL_KEY]: "paypal",
    [GPAY_LOGICAL_KEY]: "gpay",
    [PAYMENT_WALL_KEY]: "paymentwall",
    [APPLE_KEY]: "applepay",
    [COIN_PAYMENT_KEY]: "coinpayment",
};
